export default __webpack_public_path__ + "static/media/no-result.fb3ad3af.png";